import { appendLocalMessage, ChatAPI } from '@guuru/chat-web';
import events from '@guuru/events-web';

const addQuestion = (question) => {
  const isForm = ChatAPI.storeRetrieveChannel() === 'form';
  const message = ChatAPI.messages.createAnonymousTextMessage(
    question,
    false,
    false,
    isForm ? { messageStyle: 'smartForm' } : undefined,
  );
  ChatAPI.storeQuestion(question);
  ChatAPI.pushPendingMessages(message);
  return message;
};

const storeQuestion = (question) => {
  const message = addQuestion(question);
  appendLocalMessage(message);
};

export default {
  validate() {
    return true;
  },

  render(partnerId) {
    const questionFromPayload = ChatAPI.storeRetrieveQuestion(partnerId);
    if (questionFromPayload) {
      storeQuestion(questionFromPayload);
      return { goToNextStep: true };
    }
    return { goToNextStep: false };
  },

  processResponse(partnerId, { text }) {
    events.questionSubmitted(text);
    return storeQuestion(text);
  },
};
